import { render, staticRenderFns } from "./SubSection.vue?vue&type=template&id=12ec8eb1&"
import script from "./SubSection.vue?vue&type=script&lang=js&"
export * from "./SubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports